import { Box, CircularProgress } from '@mui/material'
import React from 'react'

const FullPageLoader: React.FC = () => {
    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // backgroundColor: '#f4f4f40d',
                    // backdropFilter: 'blur(5px)',
                    zIndex: 9999,
                }}
            >
                <CircularProgress
                    sx={{
                        color: '#D7A833',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        },
                    }}
                    size={40}
                    thickness={3}
                />
            </Box>
        </>
    )
}

export default FullPageLoader
